import { CATEGORIES } from '@data/src/categories';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import makeStoreUrl from '@ui/utils/makeStoreUrl';
import { useStyles } from '@ui/utils/makeStyles';
import properCase from '@utils/properCase';
import Link from 'next/link';
import React from 'react';

type ProductBreadcrumbsProps = {
  product: guesthouse.Product;
}

const ProductBreadcrumbs: React.FC<ProductBreadcrumbsProps> = (props) => {
  const { theme } = useStyles();
  const { product } = props;

  const publicCategory = CATEGORIES.filter(category => category.public)
    .map(category => category.id)
    .includes(product.category[0]);

  return (
    <Breadcrumbs
      aria-label="breadcrumbs"
      style={{
        fontSize: 12,
        fontFamily: theme.gh_vars?.circular,
      }}
    >
      <Link
        href={makeStoreUrl('/shop')}
        style={{
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        
        Shop
        
      </Link>
      {publicCategory && (
        <Link
          href={makeStoreUrl(`/shop/categories/${product.category}`)}
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
        >

          {properCase(product.category?.toString(), '-', true)}

        </Link>
      )}
      <Typography
        variant="caption1"
        style={{
          color: theme.palette.common.black
        }}
      >
        {product.title}
      </Typography>
    </Breadcrumbs>
  );
};

export default ProductBreadcrumbs;
